import { cn } from "~/design-system/lib/utils";

type HtmlContentProps = {
  content: string;
  className?: string;
};

export function HtmlContent({ content, className }: HtmlContentProps) {
  if (!content) return null;

  return (
    <div className={cn("max-w-full py-6 sm:py-8", className)}>
      <div
        className={cn(
          "prose prose-sm max-w-full leading-relaxed sm:prose-base",
          // Mobile-first typography
          "prose-h1:mb-3 prose-h1:mt-4 prose-h1:text-2xl sm:prose-h1:mb-4 sm:prose-h1:mt-6 sm:prose-h1:text-4xl",
          "prose-h2:mb-2 prose-h2:mt-3 prose-h2:text-xl sm:prose-h2:mb-3 sm:prose-h2:mt-5 sm:prose-h2:text-3xl",
          "prose-h3:mb-2 prose-h3:mt-3 prose-h3:text-lg sm:prose-h3:mb-2 sm:prose-h3:mt-4 sm:prose-h3:text-2xl",
          "prose-h4:mb-2 prose-h4:mt-2 prose-h4:text-base sm:prose-h4:mb-2 sm:prose-h4:mt-3 sm:prose-h4:text-xl",
          "prose-h5:mb-1 prose-h5:mt-2 prose-h5:text-sm sm:prose-h5:mb-2 sm:prose-h5:mt-2 sm:prose-h5:text-lg",
          "prose-h6:mb-1 prose-h6:mt-2 prose-h6:text-sm sm:prose-h6:mb-2 sm:prose-h6:mt-2 sm:prose-h6:text-lg",
          // Paragraph styling
          "prose-p:mb-2 prose-p:text-sm prose-p:leading-7 sm:prose-p:mb-4 sm:prose-p:text-lg sm:prose-p:leading-8",
          // Strong text
          "prose-strong:font-bold",
          // Lists
          "prose-ul:mb-3 prose-ul:pl-4 prose-ul:text-sm sm:prose-ul:mb-4 sm:prose-ul:pl-6 sm:prose-ul:text-base",
          "prose-ol:mb-3 prose-ol:pl-4 prose-ol:text-sm sm:prose-ol:mb-4 sm:prose-ol:pl-6 sm:prose-ol:text-base",
          "prose-li:mb-1 sm:prose-li:mb-2",
          // Links
          "prose-a:break-words prose-a:text-sm sm:prose-a:text-base",
          // Images - responsive and prevent overflow
          "prose-img:my-0 prose-img:h-auto prose-img:w-full prose-img:max-w-full prose-img:rounded-lg sm:prose-img:rounded-xl",
          // Tables - mobile scrollable, desktop normal
          "prose-table:mb-4 prose-table:w-full prose-table:overflow-x-auto sm:prose-table:mb-6",
          "prose-tr:mb-2 prose-tr:flex prose-tr:flex-col prose-tr:items-start prose-tr:gap-2 prose-tr:border-0 sm:prose-tr:mb-0 sm:prose-tr:flex-row sm:prose-tr:items-center sm:prose-tr:gap-4 sm:prose-tr:pb-0",
          "prose-th:flex prose-th:flex-1 prose-th:flex-col prose-th:gap-1 prose-th:text-left prose-th:text-xs prose-th:font-semibold sm:prose-th:gap-2 sm:prose-th:text-sm",
          "prose-td:flex prose-td:flex-1 prose-td:flex-col prose-td:gap-1 prose-td:p-0 prose-td:text-xs sm:prose-td:gap-2 sm:prose-td:text-sm",
          // Ensure text appears before images in mobile view
          "prose-th:order-1 prose-th:text-center sm:prose-th:order-none sm:prose-th:text-left",
          "prose-td:order-1 prose-td:text-center sm:prose-td:order-none sm:prose-td:text-left",
          "[&_td:has(img)]:order-2 sm:[&_td:has(img)]:order-none",
          // Blockquotes
          "prose-blockquote:my-3 prose-blockquote:border-l-2 prose-blockquote:pl-3 prose-blockquote:text-sm sm:prose-blockquote:my-4 sm:prose-blockquote:pl-4 sm:prose-blockquote:text-base",
          // Code blocks
          "prose-code:break-words prose-code:text-xs sm:prose-code:text-sm",
          "prose-pre:overflow-x-auto prose-pre:p-3 prose-pre:text-xs sm:prose-pre:p-4 sm:prose-pre:text-sm",
        )}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
}
